/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrgSMSPrefResponse } from "../models/OrgSMSPrefResponse";
import type { OrgSMSPrefUpdate } from "../models/OrgSMSPrefUpdate";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class OrgSmsPrefsService {
  /**
   * Update Organization SMS Preferences
   * Update an organization's sms preferences by its ID using specified attributes
   * within OrgSMSPrefUpdate to update the database.
   * @returns OrgSMSPrefResponse Successful Response
   * @throws ApiError
   */
  public static updateOrgSmsPrefs({
    prefId,
    requestBody,
  }: {
    prefId: number;
    requestBody: OrgSMSPrefUpdate;
  }): CancelablePromise<OrgSMSPrefResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/org_sms_prefs/{pref_id}",
      path: {
        pref_id: prefId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }
}
